import { formatRelative } from "../dashboard/format";

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

// When someone was added to the team: relative for the first week
// ("2 days ago"), then a date with its year ("3 Oct 2025") — a list can span
// years, so the dashboard's year-less short date would be ambiguous here.
export function formatAddedAt(iso, language, now = new Date()) {
  const time = new Date(iso);
  if (!iso || Number.isNaN(time.getTime())) return "";
  if (now.getTime() - time.getTime() < WEEK_MS) {
    return formatRelative(iso, language, now);
  }
  const options = { day: "numeric", month: "short", year: "numeric" };
  try {
    return new Intl.DateTimeFormat(language, options).format(time);
  } catch {
    return new Intl.DateTimeFormat("en", options).format(time);
  }
}

export function displayName(storeUser) {
  return storeUser?.user?.name || storeUser?.user?.email || "";
}
